import { render, staticRenderFns } from "./FormTag.vue?vue&type=template&id=4ea47138&scoped=true"
import script from "./FormTag.vue?vue&type=script&lang=js"
export * from "./FormTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea47138",
  null
  
)

export default component.exports